import { render, staticRenderFns } from "./WorkflowPresetAdditionalDialog.vue?vue&type=template&id=2d5f7d66&scoped=true&"
import script from "./WorkflowPresetAdditionalDialog.vue?vue&type=script&lang=ts&"
export * from "./WorkflowPresetAdditionalDialog.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowPresetAdditionalDialog.vue?vue&type=style&index=0&id=2d5f7d66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5f7d66",
  null
  
)

export default component.exports